import React, { PureComponent } from 'react';
import { connect } from 'unistore/react';
import { Flex, Box } from 'reflexbox';
import Icon from '../../../../../core/scripts/components/Icon';

import { currentDataSelector } from '../../Selectors';

import GroupItem from './GroupItem';

import './ResultSeats.styl';

class ResultSeats extends PureComponent {
  render() {
    const { data, seatsRef } = this.props;

    if (!data) {
      return null;
    }

    return (
      <div className="result-seats" ref={seatsRef}>
        <Flex justify="center" className="result-seats-header">
          <Flex column align="flex-end" justify="space-between" className="eu">
            <div className="result-seats-header-title">Sitze im EU-Parlament
            <div className="light">nach europäischen Fraktionen</div>
            </div>
            <div className="result-seats-header-seatcount">{data.seatsTotal}</div>
          </Flex>
          <Flex column justify="space-between" className="de">
            <div className="result-seats-header-title">davon aus Deutschland</div>
            <div className="result-seats-header-seatcount">{data.seatsTotalDE}</div>
          </Flex>
        </Flex>
        <div className="result-col-icon">
          <Icon type="arrow-curved"/>
        </div>
        {data.groups.map(group => (
          <GroupItem key={group.name} data={group} />
        ))}
        <Flex justify="space-between" className="result-seats-footer">
          <div className="eu">Anzahl Parteien: <strong>{data.partiesTotal}</strong></div>
          <div className="de"><strong>{data.partiesTotalDE}</strong> aus Deutschland</div>
        </Flex>
      </div>
    );
  }
}

export default connect(state => ({
  data: currentDataSelector(state)
}))(ResultSeats);
